import styled from "styled-components";
import { FormWrapper, OrangeAccentCard } from "../../styles/shared";
import TableContainer from '@mui/material/TableContainer';

export const DashboardWrapper = styled.div`
  background: #0a0e27;
  min-height: 100vh;
  position: relative;
  margin: calc(-24px - 1.5rem - 4.375rem) -24px 0 -24px;
  padding-top: calc(4.375rem + 1.5rem);
`;

export const PageHeader = styled.div`
  position: relative;
  z-index: 1;
  padding: 24px 0 0 0;
  margin-bottom: 24px;
  
  h1 {
    color: #ffffff;
    font-size: 32px;
    font-weight: 700;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    
    i {
      color: #f29205;
      font-size: 36px;
      text-shadow: 0 0 10px rgba(242, 146, 5, 0.5);
    }
  }
`;

export const FilterCard = styled(OrangeAccentCard)`
  position: relative;
  z-index: 1;
  padding: 20px !important;
  
  @media (min-width: 768px) {
    padding: 32px !important;
  }
`;

export const FilterTitle = styled.div`
  color: #f29205;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-shadow: 0 0 10px rgba(242, 146, 5, 0.3);
  
  @media (min-width: 768px) {
    font-size: 18px;
    margin-bottom: 24px;
    gap: 10px;
  }
  
  i {
    font-size: 18px;
    color: #ff6b35;
    filter: drop-shadow(0 0 5px rgba(255, 107, 53, 0.5));
    
    @media (min-width: 768px) {
      font-size: 20px;
    }
  }
`;

export const ShortcutRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 18px;
`;

export const ShortcutBtn = styled.button`
  background: ${({ $active }) =>
    $active ? 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)' : 'transparent'};
  border: 1px solid ${({ $active }) => ($active ? '#f29205' : 'rgba(242, 146, 5, 0.35)')};
  color: ${({ $active }) => ($active ? '#ffffff' : 'rgba(242, 146, 5, 0.8)')};
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  line-height: 1.5;
  box-shadow: ${({ $active }) => ($active ? '0 2px 10px rgba(242, 146, 5, 0.35)' : 'none')};

  &:hover {
    background: ${({ $active }) =>
      $active ? 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)' : 'rgba(242, 146, 5, 0.12)'};
    border-color: #f29205;
    color: ${({ $active }) => ($active ? '#ffffff' : '#f29205')};
  }
`;

export const StyledFilterFormWrapper = styled(FormWrapper)`
  @media (max-width: 767px) {
    .MuiFormControl-root {
      .MuiOutlinedInput-root {
        height: 48px !important;
        min-height: 48px !important;
        
        .MuiInputBase-input {
          height: 48px !important;
          padding: 12px 14px !important;
          font-size: 14px !important;
        }
      }
      
      .MuiInputLabel-root {
        font-size: 14px !important;
      }
    }
    
    .mobile-button,
    button.mobile-button {
      width: 100% !important;
      justify-content: center !important;
      padding: 10px 20px !important;
      font-size: 14px !important;
      height: 44px !important;
      min-height: 44px !important;
      max-height: 44px !important;
      
      & > span {
        font-size: 14px !important;
      }
      
      svg {
        width: 18px !important;
        height: 18px !important;
      }
    }
  }
`;

// Exportando FormWrapper compartilhado
export { FormWrapper };

export const ContentArea = styled.div`
  position: relative;
  z-index: 1;
  padding: 16px 16px 0 16px;
  
  @media (min-width: 768px) {
    padding: 24px 24px 0 24px;
  }
  
  @media (min-width: 1200px) {
    padding: 24px 72px 0 72px;
  }
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  margin-top: 32px;
  margin-bottom: 32px;
`;

export const StatCard = styled(OrangeAccentCard)`
  text-align: center;
  padding: 24px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(242, 146, 5, 0.4);
  }
  
  .stat-icon {
    font-size: 48px;
    color: #f29205;
    margin-bottom: 16px;
    filter: drop-shadow(0 0 10px rgba(242, 146, 5, 0.5));
  }
  
  .stat-value {
    font-size: 36px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 8px;
  }
  
  .stat-label {
    font-size: 14px;
    color: #b0b0b0;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  
  .stat-change {
    font-size: 12px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    
    &.positive {
      color: #4caf50;
    }
    
    &.negative {
      color: #ff4444;
    }
  }
`;

export const ChartsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 24px;
    margin-bottom: 32px;
  }
`;

export const ChartCard = styled(OrangeAccentCard)`
  padding: 16px;
  overflow: hidden;
  
  @media (min-width: 768px) {
    padding: 24px;
  }
`;

export const ChartTitle = styled.h3`
  color: #f29205;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  
  @media (min-width: 768px) {
    font-size: 20px;
    margin: 0 0 24px 0;
    gap: 10px;
  }
  
  i {
    font-size: 18px;
    color: #ff6b35;
    
    @media (min-width: 768px) {
      font-size: 22px;
    }
  }
`;

export const TableCard = styled(OrangeAccentCard)`
  padding: 20px;
  margin-bottom: 24px;
  
  @media (min-width: 768px) {
    padding: 24px;
    margin-bottom: 32px;
  }
`;

export const TableTitle = styled.h3`
  color: #f29205;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  
  @media (min-width: 768px) {
    font-size: 20px;
    margin: 0 0 24px 0;
    gap: 10px;
  }
  
  i {
    font-size: 20px;
    color: #ff6b35;
    
    @media (min-width: 768px) {
      font-size: 22px;
    }
  }
`;

export const StyledTableContainer = styled(TableContainer)`
  width: 100%;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  -webkit-overflow-scrolling: touch !important;
  
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(242, 146, 5, 0.5);
    border-radius: 4px;
    
    &:hover {
      background: rgba(242, 146, 5, 0.7);
    }
  }
  
  .MuiTable-root {
    min-width: 500px !important;
    
    @media (min-width: 768px) {
      min-width: 600px !important;
    }
  }
`;

export const ProductsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 500px;
  
  @media (min-width: 768px) {
    min-width: 600px;
  }
  
  thead {
    tr {
      border-bottom: 2px solid rgba(242, 146, 5, 0.3);
    }
    
    th {
      color: #f29205;
      font-weight: 600;
      font-size: 12px;
      text-align: left;
      padding: 10px 8px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      white-space: nowrap;
      
      @media (min-width: 768px) {
        font-size: 14px;
        padding: 12px;
      }
    }
  }
  
  tbody {
    tr {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      transition: background 0.2s ease;
      
      &:hover {
        background: rgba(242, 146, 5, 0.05);
      }
    }
    
    td {
      color: #e0e0e0;
      font-size: 13px;
      padding: 10px 8px;
      white-space: nowrap;
      
      @media (min-width: 768px) {
        font-size: 14px;
        padding: 12px;
      }
    }
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px 24px;
  color: #b0b0b0;
  
  i {
    font-size: 64px;
    color: #f29205;
    margin-bottom: 16px;
    opacity: 0.5;
  }
  
  p {
    font-size: 18px;
    margin: 0;
  }
  
  span {
    font-size: 14px;
    display: block;
    margin-top: 8px;
  }
`;

